import { Box, Container } from '@mui/material';
import PageHeader from 'components/common/PageHeader/PageHeader';
import ImportOpenFactsDialog from 'components/dialogs/ImportOpenFactsDialog';
import CustomButton from 'components/buttons/CustomButton/CustomButton';
import useGlobalStyles from 'styles/globalStyles';
import { useState } from 'react';
import BeautyProductsTable from './BeautyProductsTable';


export default function BeautyProductsPage() {
  const globalStyles = useGlobalStyles();
  const [importOpen, setImportOpen] = useState(false);

  return (
    <Box className={globalStyles.container}>
      <Container
        maxWidth={'xl'}
        className={globalStyles.container}
      >
        <Box pt={2}>
          <PageHeader
            title={'Beauty Products'}
            buttons={[
              <CustomButton
                key="auto-import"
                text="Auto Import"
                height={38}
                onClick={() => setImportOpen(true)}
              />,
            ]}
          />
        </Box>

        <Box mt={3}>
          <BeautyProductsTable />
        </Box>
      </Container>

      <ImportOpenFactsDialog
        open={importOpen}
        onClose={() => setImportOpen(false)}
      />
    </Box>
  );
}
